// extracted by mini-css-extract-plugin
export default {"paper":"paper__aKnnF","loader-bar":"loader-bar__xYQqk","message":"message__lASOP","icon-error":"icon-error__c4klE","name":"name__0pjUP"};